import axios from "axios";

export class ApiError extends Error {
  readonly status: number;
  readonly code: string | undefined;

  constructor(message: string, status: number, code?: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
  }
}

export function toApiError(err: unknown): never {
  if (axios.isAxiosError(err)) {
    const status = err.response?.status ?? 0;
    const message: string =
      err.response?.data?.error ?? err.message ?? "Request failed";
    const code = err.response?.data?.code
      ? (err.response.data.code as string)
      : undefined;
    throw new ApiError(message, status, code);
  }
  if (err instanceof Error) throw new ApiError(err.message, 0);
  throw new ApiError("Unknown error", 0);
}
